class CollectionPage extends HTMLElement {
  connectedCallback() {
    this.sid = this.dataset.sectionId;
    this.bind();
    window.addEventListener('popstate', () => this.load(location.href, false));
  }
  get form() { return this.querySelector('[data-filters]'); }
  get results() { return this.querySelector('[data-results]'); }

  bind() {
    const form = this.form;
    form.addEventListener('change', () => this.submit());
    form.addEventListener('submit', (e) => { e.preventDefault(); this.submit(); });
    form.querySelectorAll('input[type=number]').forEach((i) => i.addEventListener('input', theme.debounce(() => this.submit(), 500)));
    form.querySelector('[data-clear]').addEventListener('click', (e) => { e.preventDefault(); this.load(e.currentTarget.href); });
    this.querySelectorAll('[data-close-filters]').forEach((b) => b.addEventListener('click', () => this.panel(false)));
    this.bindResults();
    document.addEventListener('keydown', (e) => e.key === 'Escape' && this.panel(false));
  }

  bindResults() {
    const r = this.results;
    const open = r.querySelector('[data-open-filters]');
    open && open.addEventListener('click', () => this.panel(true));
    r.querySelectorAll('[data-sort]').forEach((b) => b.addEventListener('click', () => this.setSort(b.dataset.sort)));
    const sel = r.querySelector('[data-sort-select]');
    sel && sel.addEventListener('change', () => this.setSort(sel.value));
    r.querySelectorAll('[data-set-cols]').forEach((b) => b.addEventListener('click', () => {
      this.dataset.cols = b.dataset.setCols;
      r.querySelectorAll('[data-set-cols]').forEach((x) => x.setAttribute('aria-pressed', x === b));
    }));
    r.querySelectorAll('[data-remove],[data-page]').forEach((a) => a.addEventListener('click', (e) => {
      e.preventDefault();
      this.load(a.href);
      if (a.hasAttribute('data-page')) window.scrollTo({ top: this.offsetTop - 140, behavior: theme.reduce ? 'auto' : 'smooth' });
    }));
  }

  panel(open) {
    this.form.classList.toggle('is-open', open);
    this.querySelector('.mc__scrim').hidden = !open;
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) this.form.querySelector('button').focus();
  }

  setSort(v) {
    this.form.querySelector('[data-sort-input]').value = v;
    this.submit();
  }

  submit() {
    const p = new URLSearchParams();
    new FormData(this.form).forEach((v, k) => v !== '' && p.append(k, v));
    this.load(`${this.form.action.split('?')[0]}?${p.toString()}`);
  }

  async load(url, push = true) {
    this.results.classList.add('is-loading');
    try {
      const u = new URL(url, location.origin);
      u.searchParams.set('section_id', this.sid);
      const html = await (await fetch(u)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newRes = doc.querySelector('[data-results]');
      const newForm = doc.querySelector('[data-filters]');
      if (!newRes || !newForm) throw new Error('bad response');

      // keep user's open/closed groups
      const open = new Set([...this.form.querySelectorAll('details[open]')].map((d) => d.dataset.id));
      newForm.querySelectorAll('details').forEach((d) => (open.has(d.dataset.id) ? d.setAttribute('open', '') : d.removeAttribute('open')));
      const focusName = document.activeElement && document.activeElement.name;
      this.form.querySelector('[data-groups]').innerHTML = newForm.querySelector('[data-groups]').innerHTML;
      this.form.querySelector('[data-sort-input]').value = newForm.querySelector('[data-sort-input]').value;
      this.form.querySelector('[data-show-label]').textContent = newForm.querySelector('[data-show-label]').textContent;
      this.form.querySelector('[data-clear]').href = newForm.querySelector('[data-clear]').href;
      this.form.querySelectorAll('input[type=number]').forEach((i) => i.addEventListener('input', theme.debounce(() => this.submit(), 500)));
      const keepCols = this.dataset.cols;
      this.results.innerHTML = newRes.innerHTML;
      this.dataset.cols = keepCols;
      this.results.querySelectorAll('[data-set-cols]').forEach((x) => x.setAttribute('aria-pressed', x.dataset.setCols === keepCols));
      this.bindResults();
      if (focusName) { const el = this.form.querySelector(`[name="${focusName}"]`); el && el.type !== 'checkbox' && el.focus(); }
      if (push) history.pushState({}, '', u.pathname + u.search.replace(/[?&]section_id=[^&]*/, '').replace(/^&/, '?'));
    } catch (e) {
      location.href = url;
    } finally {
      this.results.classList.remove('is-loading');
    }
  }
}
customElements.define('collection-page', CollectionPage);
